export const dataHome = [

    'Carioca de 23 anos, sou desenvolvedor web focado em front-end. Me concentro em escrever HTML acessível, usando práticas modernas de CSS, JavaScript e React Js. Também estou me aprimorando em TypeScript, mas posso me adaptar a quaisquer ferramentas necessárias. Meu objetivo com cada projeto é produzir experiências envolventes e agradáveis para cada usuário, usando código de alta qualidade.'

];

export const dataContact = () => {

    const email = 'contatolucasalmeida2@gmail.com';

    function copyText(){

        navigator.clipboard.writeText(email);

    }

    return (

        <p>
            Eu adoraria ouvir sobre o que você está trabalhando e como eu poderia ajudar. Atualmente estou em busca de recolocação profissional e estou aberto a oportunidades. Por favor, sinta-se à vontade para verificar meus perfis e entrar em contato enviando um email para <span className="email_text" onClick={copyText} title='Clique para copiar!'>{email}</span> ou usando o formulário abaixo.
        </p>

    )

}